<!--
  Component: Monorepo
  Description: A section describing why vocabulary needs to be a monorepo
  Props: None
  Nested Components: [ Step ]
-->

<template>
    <div class="monorepo page-section">
        <div class="container has-bottom-link">
            <p class="title is-2 has-text-gray">Multiple ways to use</p>
            <span class="subtitle is-5 sub-title spacer"><a href="https://cc-vocabulary.netlify.app/?path=/docs/vocabulary-structure--page" target="_blank" rel="noopener">Vocabulary is comprised of 3 packages</a> that can be combined or used individually. Use only the parts of Vocabulary that you need for your project.</span>
        </div>
    </div>
</template>

<script>
export default {
    name:'Monorepo'
}
</script>
